export const profileApiPath = '/admin-backend/api/public/users/context-token/me'

// Calling probestack.io directly from a localhost:5173 origin is cross-site,
// so the browser drops the ProbeStack session cookie even when you're logged
// in there (SameSite/third-party-cookie restrictions). In dev, the caller
// (session-profile-service.ts) routes through the Vite proxy at this prefix
// instead, which injects the local dev token as that cookie server-side —
// no browser cookie policy involved. This file stays free of
// `import.meta.env` so it can be imported from vite.config.ts too.
export const localProfileProxyPrefix = '/local-profile-api'
export const profileApiUrl = `https://probestack.io${profileApiPath}`
